import * as HttpService from "../../../../service/HttpService";

export const search = (param) => {
    return HttpService.post(HttpService.DOMAIN + "/MbCustElecTmplMeteringBilling/unit" ,param);
};
export const searchSettlement = (param) => {
    return HttpService.post(HttpService.DOMAIN + "/meterFiles/getMeasPointId" ,param);
};

export const excelExport = () => {
    return HttpService.get(HttpService.DOMAIN + "/easypoi/excelexport");
};
